(() => {
  const lang = document.documentElement.lang.split('-')[0];
  if (!['de', 'es'].includes(lang)) return;
  const update = () => {
    document.querySelectorAll('.jdgm-widget .jdgm-sort-dropdown-label').forEach(node => {
      if (node.textContent.trim() === 'Sort by') node.textContent = lang === 'de' ? 'Sortieren nach' : 'Ordenar por';
    });
    document.querySelectorAll('.jdgm-widget .jdgm-paginate__page[aria-label]').forEach(node => {
      const match = /^Page (\d+)$/.exec(node.getAttribute('aria-label'));
      if (match) node.setAttribute('aria-label', `${lang === 'de' ? 'Seite' : 'Página'} ${match[1]}`);
    });
    document.querySelectorAll('.jdgm-widget .jdgm-rev-widg__summary-stars[aria-label]').forEach(node => {
      const match = /^Average rating is ([\d.]+) stars$/.exec(node.getAttribute('aria-label'));
      if (match) node.setAttribute('aria-label', lang === 'de' ? `Durchschnittliche Bewertung: ${match[1].replace('.', ',')} Sterne` : `Valoración media: ${match[1].replace('.', ',')} estrellas`);
    });
    document.querySelectorAll('.jdgm-widget .jdgm-histogram__star[aria-label]').forEach(node => {
      const match = /^(\d+%) \((\d+)\) reviews with (\d+) star rating$/.exec(node.getAttribute('aria-label'));
      if (match) node.setAttribute('aria-label', lang === 'de' ? `${match[1]} (${match[2]}) Bewertungen mit ${match[3]} Sternen` : `${match[1]} (${match[2]}) reseñas con ${match[3]} estrellas`);
    });
  };
  update();
  new MutationObserver(update).observe(document.body, {childList: true, subtree: true});
})();
